import { ErrorHandler, Injector, NgModule, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { GenericErrorComponent } from './generic-error/generic-error.component';
import { ErrorHandlerService } from './error-handler.service';
import { ErrorScreensizeMonitorComponent } from './error-screensize-monitor/error-screensize-monitor.component';

@NgModule({
  declarations: [PageNotFoundComponent, GenericErrorComponent, ErrorScreensizeMonitorComponent],
  imports: [
    CommonModule
  ],
  exports: [
    ErrorScreensizeMonitorComponent
  ],
  providers: [
    // ErrorHandlerService,
    {provide: ErrorHandler, useFactory: getErrorHandler, deps: [Injector, NgZone]},
    // {provide: ErrorHandler, useClass: ErrorHandlerService, deps: [Injector]},

  ]
})
export class ErrorsModule { }

function getErrorHandler(injector: Injector, zone: NgZone): ErrorHandlerService {
  return new ErrorHandlerService(injector, zone);
}
